<div class="container-fluid mainBody">

  <div class="row mt-2">
    <div class="col-12 d-flex justify-content-between align-items-center">
      <h4>Correos IA</h4>
      <button mat-raised-button color="primary" (click)="conectar()">
        <mat-icon>add</mat-icon> Conectar correo
      </button>
    </div>
  </div>

  <div class="row mt-2">
    <div class="col-12">
      <p>
        Conecta un buzón de correo para que los correos que lleguen se analicen automáticamente
        con IA. Los que se detecten como gasto se guardarán en "Facturas sin contabilizar" igual
        que si los hubieras subido a mano.
      </p>
      <div class="alert alert-warning" role="alert">
        La cuenta de correo debe ser obligatoriamente de <strong>Gmail</strong> y tener activada la
        <strong>verificación en dos pasos</strong>. Además, deberás crear una
        <a href="https://myaccount.google.com/apppasswords" target="_blank" rel="noopener noreferrer">contraseña de aplicación</a>
        para poder conectarla.
      </div>
    </div>
  </div>

  <ng-container *ngIf="loading">
    <mat-spinner></mat-spinner>
  </ng-container>

  <div class="row mt-2 mb-4" *ngIf="!loading">
    <div class="col-12">

      <mat-card class="mat-elevation-z2" *ngIf="cuentas.length == 0">
        <mat-card-title>
          <h4>No tienes ningún correo conectado</h4>
        </mat-card-title>
      </mat-card>

      <mat-card class="mat-elevation-z2" *ngIf="cuentas.length > 0">
        <mat-card-content>
          <div class="table-responsive">
            <table mat-table [dataSource]="cuentas" class="w-100">

              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef class="th-bg">Correo</th>
                <td mat-cell *matCellDef="let row">{{ row.email }}</td>
              </ng-container>

              <ng-container matColumnDef="estado">
                <th mat-header-cell *matHeaderCellDef class="th-bg">Estado</th>
                <td mat-cell *matCellDef="let row">
                  <span *ngIf="row.active && !row.lastError" class="text-success">Activo</span>
                  <span *ngIf="!row.active" class="text-muted">Pausado</span>
                  <span *ngIf="row.active && row.lastError" class="text-danger" [title]="row.lastError">Error de conexión</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="ultimaComprobacion">
                <th mat-header-cell *matHeaderCellDef class="th-bg">Última comprobación</th>
                <td mat-cell *matCellDef="let row">{{ row.lastCheckedAt ? (row.lastCheckedAt | date:'dd/MM/yyyy HH:mm') : 'Todavía no' }}</td>
              </ng-container>

              <ng-container matColumnDef="acciones">
                <th mat-header-cell *matHeaderCellDef class="th-bg"></th>
                <td mat-cell *matCellDef="let row">
                  <button mat-icon-button title="Comprobar ahora" (click)="comprobarAhora(row)" [disabled]="runningNow[row.uid]">
                    <mat-icon>{{ runningNow[row.uid] ? 'hourglass_empty' : 'refresh' }}</mat-icon>
                  </button>
                  <button mat-icon-button [title]="row.active ? 'Pausar' : 'Reactivar'" (click)="cambiarActivo(row)">
                    <mat-icon>{{ row.active ? 'pause' : 'play_arrow' }}</mat-icon>
                  </button>
                  <button mat-icon-button title="Desconectar" color="warn" (click)="desconectar(row)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
        </mat-card-content>
      </mat-card>

    </div>
  </div>

</div>
